import type { VirementQueryDTO } from '@/features/api/extranet/dto/Virement/VirementQueryDTO'
import { buildRechercheStore } from '../shared'
import type { VirementDTO } from '@/features/api/extranet/dto/Virement'

export const useRechercheVirementStore = buildRechercheStore<VirementQueryDTO, VirementDTO>({
  storeName: 'rechercheVirementStore',
  apiPath: '/virements',
  location: {
    to: 'recherche',
    domaine: 'virements'
  }
})

